import * as fs from 'firebase/firestore'
import { auth, db } from '../firebase'

export default class Request {
  private static getCollection() { return fs.collection(db, 'requests') }

  public static async create(request: { type: string } & Record<string, any>) {
    const requestedBy = auth.currentUser?.uid
    if (!requestedBy)
      throw new Error('Cannot create request while signed out')

    await fs.addDoc(Request.getCollection(), { ...request, requestedBy })
  }
}
